<template>
  <div class="card-personalizada">
    <div class="card-header text-left card-header-novedad">
      <b>Reportes por día SIESA</b>
    </div>
    <div class="card-body pl-4">
      <div class="row mt-3">
        <!-- Calendar -->
        <div class="col-12 mb-4">
          <b-form-datepicker locale="es" v-model="date" size="lg" class="mb-2 data_picker" :max="date_end"
            @input="change_date()" />
        </div>

        <!--<calendarMonth
          v-model="date"
          :max="date_end"
          :monthLabels="monthLabels"
          alignment="center"
          class="col-md-12"
        ></calendarMonth>-->

        <!-- List Files -->
        <b-row class="col-12">
          <b-col class="row col-12" v-for="(file, key_files) in getFiles" :key="key_files">
            <div class="col-md-8 mt-2">
              <div class="title-row">{{ file.name }}</div>
              <br />
              <div class="subtitle-row text-success text-uppercase">
                <span class="icon icon-checkmark mr-1" />
                Cargado
                <span class="text-dark">
                  | {{ $moment(file.created_at).format("LL") }}
                </span>
              </div>
            </div>
            <div class="col-md-4 text-right mt-2">
              <b-button pill class="text-center" variant="outline-primary"
                @click="download(file.id, file.name, key_files)">
                <!-- Download file -->
                <div v-if="processing && click_current === key_files">
                  Descargando
                  <b-spinner small />
                </div>
                <div v-else>
                  Descargar
                  <span class="icon icon-download" />
                </div>
              </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>
    <div>
      <b-modal :ref="modal_name" hide-footer centered title="Atención al mensaje:" no-close-on-backdrop
        @hidden="hideModal(modal_name)">
        <div class="d-block text-center">
          <h3 v-text="message_of_modal" />
        </div>
        <b-button class="mt-3" variant="outline-danger" block @click="hideModal(modal_name)">
          Cerrar
        </b-button>
      </b-modal>
    </div>
    <!-- end -->
  </div>
</template>

<script>
//import calendarMonth from "@/components/calendarMonth/calendarMonth.vue";

import { mapActions, mapGetters } from "vuex";

export default {
  name: "DailyReportSiesa",
  components: {
    //calendarMonth,
  },
  data: () => ({
    file: null,
    selected: false,
    date: null,
    date_end: null,
    processing: false,
    click_current: -1,
    message_of_modal: "",
    monthLabels: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic",
    ],
  }),
  computed: {
    ...mapGetters("modSiesaTips", ["getFiles", "getErrors"]),
    modal_name() {
      return "modal-daily-report-siesa";
    },
  },
  beforeMount() {
    this.date_end = this.get_today;
    this.getGetFiles();
  },
  watch: {
    getFiles() {
      if (!this.getFiles.length) {
        // Message of exist date (different of null)
        const message = this.date
          ? `para la fecha: ${this.date}`
          : "para: Reportes por día SIESA";
        this.message_of_modal = `¡Lo sentimos!, no se encontraron datos ${message}`;
        return this.showModal(this.modal_name);
      }
    },
  },
  methods: {
    ...mapActions("modSiesaTips", [
      "uploadFile",
      "downloadFile",
      "getGetFiles",
    ]),
    getReport() {
      // window.open('https://api-dev.virtualpartner.com.co/outsourcedexport/2021-12-01','_blank');
      // await this.uploadFile({})
    },
    async change_date() {
      // query of search create_at
      const query = { created_at: this.date };
      await this.getGetFiles(query);
    },
    async upload() {
      const self = this;
      const form = new FormData();
      form.append("file", self.file);
      this.processing = true;
      this.click_current = -1;
      await self.uploadFile(form);
      this.processing = false;
    },
    async download(file_id = "", name = "", key_file_click = -1) {
      this.processing = true;
      this.click_current = key_file_click;
      await this.downloadFile({ file_id, name });
      this.processing = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.data_picker {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 8px !important;

  position: relative;
  height: 44px !important;
  left: 0px;
  right: 0px;
  //top: 8px;

  /* content/00 */

  background: #ffffff !important;
  /* content/03 */

  border: 1px solid #b0bec5 !important;
  box-sizing: border-box !important;
  border-radius: 8px !important;
  margin-bottom: 16px !important;
  margin-top: 16px !important;
  float: right;

  button {
    position: absolute;
    right: inherit;
  }
}

.card-personalizada {
  padding: 0px;
  gap: 16px;

  //width: 772px;

  /* content/00 */

  background: #ffffff;
  /* Mid */

  box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.14);
  border-radius: 8px;
}

.title-row {
  /* Body Semibold */
  //font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #454545;
}

.subtitle-row {
  color: #00761a;
  background: #f6ffed;
  border-radius: 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 2px 5px;
  gap: 4px;

  //width: 95px;
  height: 24px;
  margin-top: -20px;
}
</style>

<style>
.btn_return {
  position: absolute;
  bottom: 16px;
  left: 25%;
  margin: auto;
  align-items: center;
  padding: 6px 12px;
  gap: 4px;
  width: 123px;
  height: 32px;
  /* content/00 */
  background: #ffffff;
  /* CTA/03 */
  border: 1px solid #5d5fef;
  border-radius: 4px;
  top: 50%;
}

.month-picker-wrapper {
  width: 100% !important;
  height: auto !important;
  padding-left: 0.25rem;
  margin: 0;
  border: 0;
  outline: 0;
  background: transparent;
  word-break: break-word;
  font-size: inherit;
  white-space: normal;
  cursor: pointer;
  color: #6c757d !important;
}
</style>